import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials, getErrorMessage } from '../globalFunctions';
import { School, SchoolCourse } from '../types';

export class SchoolCourseDAO {
    static async save(token: string, navigate: NavigateFunction, course: SchoolCourse) {
        if (course.id > 0) {
            return await SchoolCourseDAO.update(token, navigate, course);
        } else {
            return await SchoolCourseDAO.store(token, navigate, course);
        }
    }

    static async store(token: string, navigate: NavigateFunction, course: SchoolCourse) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/course`,
                course,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: getErrorMessage(error.response.data.error),
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async update(token: string, navigate: NavigateFunction, course: SchoolCourse) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/course/${course.id}`,
                course,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: getErrorMessage(error.response.data.error),
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async delete(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/course/${id}`,
                requestConfig
            );

            return response.data === 1;
        } catch (error: any) {
            const response = {
                message: getErrorMessage(error.response.data.error),
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
